import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import 'App.css';
import Layout from 'Layout';
import Home from 'Pages/Home';
import Inputs from 'Pages/Inputs';
import Location from 'Pages/Inputs/01_Location';
import Numbers from 'Pages/Inputs/02_Numbers';
import Housing from 'Pages/Inputs/03_Housing';
import DateSimulation from 'Pages/Inputs/04_DateSimulation';
import MailingList from 'Pages/MailingList';
import DateEmpty from 'Pages/Inputs/05_DateEmpty';
import Charts from 'Pages/Charts';
import { INPUT_STEP_NAMES } from 'Pages/Inputs/constants';


const App = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route index element={<Home />} />
          <Route path='/inputs' element={<Inputs />}>
            <Route index element={<Navigate to='location' replace />} />
            <Route path={INPUT_STEP_NAMES.location} element={<Location />} />
            <Route path={INPUT_STEP_NAMES.numbers} element={<Numbers />} />
            <Route path={INPUT_STEP_NAMES.housing} element={<Housing />} />
            <Route path={INPUT_STEP_NAMES.simulation} element={<DateSimulation />} />
            <Route path={INPUT_STEP_NAMES.empty} element={<DateEmpty />} />
            {/* TODO: constraints - do you have any constraints on when you can empty manure?
            <Route path='constraints' element={<Constraints />} /> */}
          </Route>
          <Route path='/charts' element={<Charts />} />
          <Route path='/mailinglist' element={<MailingList />} />
        </Route>

        

      </Routes>
    </Router>
  );
}

export default App;
